export default __webpack_public_path__ + "static/media/PXL_20230812_142243815.MP.6b338483.jpg";